import { __ } from '@wordpress/i18n';
import {
  TextControl,
} from '@wordpress/components';
import ColorControl from '../../../controls/ColorControl';

const Reference = ({index, itemIndex, item, handleChangeItemField, setAttributes, attributes }) => {
    const {
        referenceNameColor,
        referenceContentColor,
        style,
    } = attributes || {};
    return (
        <>
        <div id="section8">
            <TextControl
                label={__(
                    'Name',
                    'cv-builder'
                )}
                value={
                    item.name ||
                    ''
                }
                onChange={(
                    value
                ) =>
                    handleChangeItemField(
                        value,
                        index,
                        itemIndex,
                        'name'
                    )
                }
            />
            <TextControl
                label={__(
                    'Job Position',
                    'cv-builder'
                )}
                value={
                    item.jobPosition ||
                    ''
                }
                onChange={(
                    value
                ) =>
                    handleChangeItemField(
                        value,
                        index,
                        itemIndex,
                        'jobPosition'
                    )
                }
            />
            <TextControl
                label={__(
                    'Company Name',
                    'cv-builder'
                )}
                value={
                    item.company ||
                    ''
                }
                onChange={(
                    value
                ) =>
                    handleChangeItemField(
                        value,
                        index,
                        itemIndex,
                        'company'
                    )
                }
            />
            <TextControl
                label={__(
                    'Phone',
                    'cv-builder'
                )}
                value={
                    item.phone ||
                    ''
                }
                onChange={(
                    value
                ) =>
                    handleChangeItemField(
                        value,
                        index,
                        itemIndex,
                        'phone'
                    )
                }
            />
            <TextControl
                label={__(
                    'Relation',
                    'cv-builder'
                )}
                value={
                    item.relation ||
                    ''
                }
                onChange={(
                    value
                ) =>
                    handleChangeItemField(
                        value,
                        index,
                        itemIndex,
                        'relation'
                    )
                }
            />
        </div>
        {
            style !== 'style26' && style !== 'style27' && style !== 'style28' && (
                <>
            <ColorControl
                label={__(
                'Name Color',
                'cv-builder'
                )}
                color={referenceNameColor}
                colorName="referenceNameColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Company, Job Position, Phone & Relation Color',
                'cv-builder'
                )}
                color={referenceContentColor}
                colorName="referenceContentColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            </>
            )}
        </>
    )
}

export default Reference